module.exports = function() {
  return new Worker(__webpack_public_path__ + "9c2969c0fdfdbc4ee8ea.worker.js");
};